import {
  Slider,
  Radio,
  Button,
  Space,
  Card,
  Row,
  Col,
  InputNumber,
  Input,
  Select,
  Divider,
  Layout,
  Tooltip,
} from "antd";
import { useState, useEffect } from "react";
import "./App.css";

//these have to been global variable,3h
var osclist = [];
const actx = new (window.AudioContext || window.webkitAudioContext)(); //add safari compatibility
var mainNode;
var filter;
var samplingMethodID;

export function Main_control_section() {
  //#region shared functions

  function setup() {
    mainNode = actx.createGain();
    mainNode.connect(actx.destination);
    filter = actx.createBiquadFilter();
    filter.connect(mainNode);
  }
  setup();
  ///play sound func
  function playTone(freq, waveform) {
    const osc = actx.createOscillator();
    osc.type = waveform;
    osc.frequency.value = freq; //frequency of the key

    //create waves, but do not start them
    osc.connect(filter).connect(mainNode);

    osclist.push(osc);
    console.log(osc);
    return osc;
  }
  function terminate_all_oscs() {
    console.log("terminate oscs called" + osclist.length);
    if (osclist.length > 0)
      osclist.forEach((element) => {
        element.stop(actx.currentTime);
      });
    osclist = [];
  }
  //#endregion
  //#region Basic wave properties
  const wave_options = [
    {
      label: "sine",
      value: "sine",
    },
    {
      label: "square",
      value: "square",
    },
    {
      label: "sawtooth",
      value: "sawtooth",
    },
    {
      label: "triangle",
      value: "triangle",
    },
  ];
  const LOW_FREQUENCY_BOUND = 20;
  const HIGH_FREQUENCY_BOUND = 5000;
  const [waveformType, setWaveformType] = useState("sine");
  const [amplitude, setAmplitude] = useState(0.5);
  const [frequency, setFrequency] = useState(440);
  const [isMouseDown, setIsMouseDown] = useState(false);

  const onKeyPressed = (e) => {
    setFrequency(e.target.value);
  };

  const onChangeWaveform = (e) => {
    setWaveformType(e.target.value);
  };
  const onChangeAmplitude = (newVal) => {
    setAmplitude(newVal);
  };
  const onChangeFrequency = (newVal) => {
    setFrequency(newVal);
  };

  const common_frequency_items = [
    {
      label: "A",
      key: "A",
      value: 440,
    },
    {
      label: "A#",
      key: "A#",
      value: 466.16,
    },
    {
      label: "B",
      key: "B",
      value: 493.88,
    },
    {
      label: "C",
      key: "C",
      value: 523,
    },
    {
      label: "C#",
      key: "C#",
      value: 554,
    },
    {
      label: "D",
      key: "D",
      value: 587,
    },
    {
      label: "E",
      key: "E",
      value: 659,
    },
    {
      label: "F",
      key: "F",
      value: 698,
    },
    {
      label: "G",
      key: "G",
      value: 784,
    },
  ];
  //#endregion
  //#region Unison waves
  const [detune, setDetune] = useState(0);
  const [detune2, setDetune2] = useState(0);

  //#endregion
  //#region ADSR envelop
  const [attack, setAttack] = useState(1);
  const [decay, setDecay] = useState(0.5);
  const [sustain, setSustain] = useState(50);
  const [release, setRelease] = useState(0.3);

  function onMouseDownMainButton() {
    console.log("mouse down at t = " + timeElapsed);
    play_notes_main();
    mainNode.connect(actx.destination);
    osclist.forEach((element) => {
      element.connect(mainNode);
    });
    const t_pressed = actx.currentTime;
    mainNode.gain.setValueAtTime(0, t_pressed);
    //console.log("main node gain at attack start: ", mainNode.gain.value);
    mainNode.gain.linearRampToValueAtTime(amplitude, t_pressed + attack);

    mainNode.gain.setTargetAtTime(
      (sustain / 100) * amplitude,
      actx.currentTime + attack,
      decay
    );
    startSampling();
    setIsMouseDown(true);
  }

  function onMouseUpMainButton(e) {
    e.preventDefault();
    console.log("stop play called at t = " + timeElapsed);
    const t_released = actx.currentTime;
    const old_value = mainNode.gain.value * amplitude; //this take me 5 hours
    mainNode.gain.value = 0;
    osclist.forEach((element) => {
      element.disconnect(0);
      element.connect(mainNode);
    });
    mainNode.gain.cancelScheduledValues(t_released);
    mainNode.gain.setValueAtTime(old_value, t_released);
    mainNode.gain.linearRampToValueAtTime(0, t_released + release);
    mainNode.gain.setTargetAtTime(0, t_released + release, 0);

    // console.log(actx);
    // console.log(mainNode.gain);
    setTimeout(() => {
      console.log("end ASDR at t = " + timeElapsed);
      endSampling();
    }, release * 1000);
    osclist.forEach((element) => {
      element.stop(t_released + release);
    });
    setIsMouseDown(false);
  }
  //#endregion
  //#region debug and data visualization
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [sampleTimeTrigger, setSampleTimeTrigger] = useState(false);
  const TimeSamplingInterval = 100; //collect data every 0.1s
  function startSampling() {
    clearTimeout(samplingMethodID);
    setTimeElapsed(0);
    setSampleTimeTrigger(true);
    //recordedSamplingValues = [];
  }
  function endSampling() {
    clearTimeout(samplingMethodID);
    setSampleTimeTrigger(false);
  }
  useEffect(() => {
    if (sampleTimeTrigger === false) return;
    //recordedSamplingValues.push([timeElapsed, mainNode.gain.value]);
    console.log(`t = ${timeElapsed}, gain amplitude: ${mainNode.gain.value}`);
    samplingMethodID = setTimeout(() => {
      setTimeElapsed(timeElapsed + TimeSamplingInterval / 1000);
    }, TimeSamplingInterval);
  }, [sampleTimeTrigger, timeElapsed]);
  //#endregion
  //#region filters
  const [lowPass, setLowPass] = useState(3000);
  const [qualityFactor, setQualityFactor] = useState(0.4);
  function createBandFilter() {
    filter.type = "bandpass"; //many kind of pass
    //start immediately and change immediately to 0. the formula here is 1-e^c
    //find the geometric mean, which is the center frequency:
    let centerFreq = Math.sqrt(lowPass * qualityFactor);
    //set filter frequency to center pass
    filter.frequency.value = centerFreq;
    //The definition of Q factor of a band pass is
    filter.Q.value = qualityFactor;
  }
  function createLowPassFilter() {
    //get it from the sampleing rate of the audio context, which is the nyquist rate.
    //so half of it should be the max frequency of the filter requried
    filter.type = "lowpass";
    filter.frequency.value = lowPass;
    filter.Q.value = qualityFactor;
  }
  //#endregion
  //#region play methods
  //play sound immediately as one of the variable changed
  useEffect(() => {
    mainNode.gain.value = amplitude;
    play_notes_main();
    //terminate all after
    osclist.forEach((element) => {
      //console.log(actx.currentTime);
      element.stop(actx.currentTime + 1); //this is second based
    });
  }, [amplitude, frequency, waveformType, detune, detune2]);

  //play notes, but do not stop them
  function play_notes_main() {
    mainNode.gain.cancelScheduledValues(actx.currentTime);
    terminate_all_oscs();
    createLowPassFilter();

    playTone(frequency, waveformType);
    //create two additional tones with detune
    if (Math.abs(detune - 0) >= 0.01) {
      playTone(frequency, waveformType).detune.value = detune;
    }
    if (Math.abs(detune2 - 0) >= 0.01) {
      playTone(frequency, waveformType).detune.value = detune2;
    }

    //start each osc immediately
    console.log("osc count: " + osclist.length);
    osclist.forEach((element) => {
      element.start(actx.currentTime);
    });
  }
  //#endregion
  //#region React styles
  const layoutStyle = {
    borderRadius: "20px",
    overflow: "hidden",
    width: "calc(50% - 8px)",
    maxWidth: "calc(50% - 8px)",
  };
  const cardStyle = {
    textAlign: "left",
    minHeight: "40px",
    lineHeight: "20px",
    width: "420px",
    color: "#fff",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
  };
  const headerStyle = {
    textAlign: "center",
    color: "#fff",
    height: 64,
    paddingInline: 48,
    lineHeight: "64px",
    backgroundColor: "#ffff00",
    borderRadius: "20px",
  };
  //#endregion
  return (
    <Layout layoutstyle={layoutStyle}>
      <Row style={headerStyle}>
        <Divider>Wave 1</Divider>
      </Row>
      <Row>
        <Col>
          <Row>
            <Card title="Main Control" size="medium" style={cardStyle}>
              <Button
                type="primary"
                onMouseDown={onMouseDownMainButton}
                onMouseUp={onMouseUpMainButton}
              >
                Hold to play Envelope
              </Button>
              <br></br>
              <Radio.Group
                value={frequency}
                buttonStyle="solid"
                options={common_frequency_items}
                optionType="button"
                style={{ marginTop: "10px" }}
                onChange={onKeyPressed}
              />
            </Card>
          </Row>
          <Row>
            <Card title="Waveform" size="medium" style={cardStyle}>
              <Radio.Group
                options={wave_options}
                onChange={onChangeWaveform}
                value={waveformType}
                optionType="button"
              />
            </Card>
          </Row>
          <Row>
            <Card title="Frequency" size="medium" style={cardStyle}>
              <Row>
                <Slider
                  min={LOW_FREQUENCY_BOUND}
                  max={HIGH_FREQUENCY_BOUND}
                  onChange={onChangeFrequency}
                  value={typeof frequency === "number" ? frequency : 440}
                  step={1}
                  style={{ width: "100px" }}
                />
                <InputNumber
                  min={30}
                  max={3000}
                  style={{
                    margin: "0 10px",
                  }}
                  step={10}
                  value={frequency}
                  onChange={onChangeFrequency}
                />

                <Select
                  defaultValue="A"
                  style={{
                    width: 80,
                  }}
                  onChange={onChangeFrequency}
                  options={common_frequency_items}
                />
              </Row>
            </Card>
          </Row>
          <Row>
            <Card title="Amplitude" size="medium" style={cardStyle}>
              <Row>
                <Slider
                  min={0}
                  max={2}
                  onChange={onChangeAmplitude}
                  value={typeof amplitude === "number" ? amplitude : 0.5}
                  style={{ width: "100px" }}
                  step={0.01}
                />
                <InputNumber
                  min={0}
                  max={10}
                  style={{
                    margin: "0 16px",
                  }}
                  step={0.1}
                  value={amplitude}
                  onChange={onChangeAmplitude}
                />
              </Row>
            </Card>
          </Row>
        </Col>
        <Col>
          <Card
            title="Construct harmonic waves"
            size="medium"
            style={cardStyle}
          >
            <Row>
              <Tooltip
                title="[Try 10 cents SawTooth shape!] 
                 Detune is a parameter that is used to offset a played note from its base frequency. 
                 The unit for detune is cents; one cent is equivalent to 1/100 of a semitone and there are 12 semitones in an octave.
                 By detuning in cents rather than hertz, the percieved difference in pitch is normalized to whatever note is being detuned. 
                 A 10hz detune sounds much more dramatic on a low note with a lower frequency than a high note since it is a higher percentage of its frequency."
              >
                <InputNumber
                  addonBefore="Detune: "
                  addonAfter="cents"
                  min={-100}
                  max={100}
                  step={1}
                  value={detune}
                  onChange={setDetune}
                />
              </Tooltip>
              <InputNumber
                addonBefore="Detune2: "
                addonAfter="cents"
                min={-100}
                max={100}
                step={1}
                value={detune2}
                onChange={setDetune2}
              />
            </Row>
          </Card>
          <Card title="Envelope" size="medium" style={cardStyle}>
            <Row>
              <Tooltip title="Attack is the time taken for the rise of the level from null to peak.">
                <InputNumber
                  addonBefore="attack: "
                  addonAfter="seconds"
                  min={0}
                  max={5}
                  step={0.05}
                  value={attack}
                  onChange={setAttack}
                />
              </Tooltip>
              <Tooltip title="Decay is the time taken for the level to reduce from the attack level to the sustain level.">
                <InputNumber
                  addonBefore="decay: "
                  addonAfter="seconds"
                  min={0}
                  max={5}
                  step={0.05}
                  value={decay}
                  onChange={setDecay}
                />
              </Tooltip>
              <Tooltip title="Sustain is the level maintained until the key is released">
                <InputNumber
                  addonBefore="sustain: "
                  addonAfter="%"
                  min={0}
                  max={100}
                  step={1}
                  value={sustain}
                  onChange={setSustain}
                />
              </Tooltip>
              <Tooltip title="Release is the time taken for the level to decay to null">
                <InputNumber
                  addonBefore="release: "
                  addonAfter="seconds"
                  min={0}
                  max={5}
                  step={0.05}
                  value={release}
                  onChange={setRelease}
                />
              </Tooltip>
            </Row>
          </Card>

          <Card title="Low Pass Filter" size="medium" style={cardStyle}>
            <Row>
              <Tooltip title="define the low pass of the the band pass filter">
                <InputNumber
                  addonBefore="low pass frequency "
                  addonAfter="Hz"
                  min={30}
                  max={3000}
                  step={10}
                  value={lowPass}
                  onChange={setLowPass}
                />
              </Tooltip>
              <Tooltip title="Q factor is a dimensionless parameter that describes how underdamped an oscillator or resonator is. ">
                <InputNumber
                  addonBefore="Q factor"
                  addonAfter="Hz"
                  min={0}
                  max={100}
                  step={1}
                  value={qualityFactor}
                  onChange={setQualityFactor}
                />
              </Tooltip>
            </Row>
          </Card>
        </Col>
      </Row>
    </Layout>
  );
}
